/**
 * Types and mappings for interactive org preview functionality.
 * Used to connect preview card elements to their corresponding editor sections/fields.
 */

// Element identifiers for interactive preview
export type OrgPreviewElement =
  | 'logo'
  | 'name'
  | 'description'
  | 'website';

// Accordion section identifiers
export type OrgEditorSection = 'general' | 'defaults';

// Field identifiers within sections
export type OrgFieldTarget =
  | 'name'
  | 'logo'
  | 'shortName'
  | 'homeUrl'
  | 'description'
  | 'defaultSeasonMonthDays'
  | 'defaultPlayDays';

// Mapping from preview element to section/field
export const ORG_ELEMENT_TO_EDITOR: Record<
  OrgPreviewElement,
  { section: OrgEditorSection; field?: OrgFieldTarget }
> = {
  logo: { section: 'general', field: 'logo' },
  name: { section: 'general', field: 'name' },
  description: { section: 'general', field: 'description' },
  website: { section: 'general', field: 'homeUrl' },
};
